export default "https://cdn-static.gokick.com/assets/5d59d840aa8978759fe32f9d0593dfb9088da5d0/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";